/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
/* Please dont change the common error messages at any cost */
export const COMMON_UMS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  FAILURE: 'Failure',
  success: 'success',
  failure: 'failure',
  error: 'error',
  mandatoryFields: '* All fields are mandatory',
  operationSuccess: 'Operation was successful',
  name_validation_error: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  code_validation_error: 'Code has invalid characters. Allowed characters are a-z A-Z.',
  duplicate_name: 'Duplicate names are not allowed.',
  duplicate_code: 'Duplicate codes are not allowed.',
  plancomp_tier_duplicate_code: 'Duplicate tier codes are not allowed.',
  plancomp_tier_invalid_code: 'Tier code has invalid characters. Allowed characters are a-z A-Z 0-9',
  description_validation_error: 'Description should be less than 250 characters',
  invalid_email: 'Enter valid Email.',
  invalid_formReceivedDate: "Form Received Date should not be less than Service Date",
  voltransfer_duplicate_code:"Duplicate codes are not allowed.",
  voltransfer_invalid_code:"Code has invalid characters. Allowed characters are a-z A-Z 0-9",
  from_to_dates_madatory:"From and To Dates are mandatory",
  from_to_dates_diff: "From Date should be less than To Date in Date filters",
  to_dates_madatory: "Date field should not be empty",
  order_date_validation_error: 'Service Date and Form Received Date should be greater than the Order Date',
  invalid_toDate: "Please select To date for the Date Range.",
  error_message: "User account not found in the DSPro application. Kindly contact the DSPro Administrator for future assistance."
};

export const LOGIN_UMS = {
  login_invalid_credentials: 'Invalid login credentials',
  login_invalid_userName: 'Invalid login credentials',
  login_invalid_email_format: 'Invalid login credentials',
  login_password_mail: 'An email with instructions to reset the password has been sent. Please make sure  you have provided correct User Name',
  login_about_fetch_error: 'Unable to retrieve deployment information at this time.'
};

export const USER_PROFILE_UMS = {
  user_profile_updated: 'User Profile Updated Successfully',
  user_password_updated: 'Password Updated Successfully'
};

export const REGISTRATION_UMS = {
  registration_password_set: 'Password has been successfully created'
};

export const COMPANY_UMS = {
  company_duplicate_name: 'Duplicate company names are not allowed.',
  company_duplicate_code: 'Duplicate company codes are not allowed.',
  company_invalid_code: 'Company code has invalid characters. Allowed characters are a-z A-Z 0-9 - _',
  company_no_model: 'Model(s) not available.',
  company_no_type: 'Company type(s) not available.',
  company_name_invalid_character: 'Company name has invalid characters. Allowed characters are A-Z a-z 0-9 - _  *.'
};

export const SETTINGS_UMS = {
  duplicate_name: 'Duplicate Settings names are not allowed.',
  duplicate_code: 'Duplicate Setting codes are not allowed.',
  invalid_code: 'Settings code has invalid characters. Allowed characters are a-z A-Z 0-9',
  name_invalid_character: 'Settings name has invalid characters. Allowed characters are A-Z a-z 0-9 - _  *.',
  invalid_value: "Invalid Value. For 'DATE' type, valid pattern is DD-MM-YYYY. For'INTEGER' type, valid pattern is only integers. For 'NUMBER' type, valid pattern is decimal with atleast one decimal place", 
};

export const TRAININGS_UMS = {
  duplicate_name: 'Duplicate Training names are not allowed.',
  duplicate_code: 'Duplicate Training codes are not allowed.',
  invalid_code: 'Training code has invalid characters. Allowed characters are a-z A-Z 0-9',
  name_invalid_character: 'Training name has invalid characters. Allowed characters are A-Z a-z 0-9 - _  *.',
}

export const CHARGESFEES_UMS = {
  duplicate_name: 'Duplicate Fee names are not allowed.',
  duplicate_code: 'Duplicate Fee codes are not allowed.',
  invalid_code: 'Fee code has invalid characters. Allowed characters are a-z A-Z 0-9',
  invalid_name: 'Fee name has invalid characters. Allowed characters are A-Z a-z 0-9 - _ *'
};

export const MARKETS_REGIONS_UMS = {
  mr_duplicate_market_code: 'Duplicate market codes are not allowed.',
  mr_duplicate_market_name: 'Duplicate market names are not allowed.',
  mr_duplicate_region_code: 'Duplicate region codes are not allowed.',
  mr_duplicate_region_name: 'Duplicate region names are not allowed.',
  mr_invalid_market_name: 'Market name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  mr_invalid_market_abbr: 'Market abbreviation has invalid characters. Allowed characters are a-z A-Z 0-9 - _ .',
  mr_invalid_region_name: 'Region name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  mr_invalid_region_code: 'Region code should be between 2 and 5 characters and allowed characters are a-z A-Z 0-9 -_.',
  mr_invalid_region_currency_code: 'Currency / Region Code has invalid characters. Allowed characters are a-z A-Z 0-9 - _.'
};

export const CROSS_BORDER_UMS = {
  cb_invalid_factor: 'Factor value must be a positive integer (Examples: 1, 3.2, .034).',
  cb_invalid_from_to: '"From Region" can\'t be same as "To Region".',
  cb_duplicate_rollup: 'Duplicate roll up rules are not allowed.'
};

export const FOREX_RATE_UMS = {
  fr_invalid_factor: 'Factor value must be a positive integer (Examples: 1, 3.2, .034).',
  fr_invalid_from_to: '"From Currency" can\'t be same as "To Currency".',
  fr_duplicate_rollup: 'Duplicate Forex Rate rules are not allowed.'
};

export const PARTICIPANT_STATUS_UMS = {
  ps_duplicate_name: 'Duplicate status names are not allowed.',
  ps_invalid_name: 'Status name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  ps_duplicate_code: 'Duplicate status codes are not allowed.',
  ps_invalid_code: 'Status Code has invalid characters. Allowed characters are a-z A-Z 0-9'
};

export const CAR_TYPE_STATUS_UMS = {
  ct_duplicate_name: 'Duplicate names are not allowed.',
  ct_duplicate_code: 'Duplicate codes are not allowed.'
};

export const PRICE_TIERS_UMS = {
  pt_duplicate_name: 'Duplicate names are not allowed.',
  pt_duplicate_code: 'Duplicate codes are not allowed.',
  pt_invalid_name: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  pt_invalid_description: 'Description has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  pt_invalid_code: 'Code has invalid characters. Allowed characters are a-z A-Z.',
};

export const CARD_EDIT_UMS = {
  pt_update_success_msg: 'PriceTier updated successfully',
  sh_update_success_msg: 'S&H updated successfully',
  pdd_update_success_msg: 'PDD Updated successfully',
  comp_plan_update_success_msg: 'Compensation Plan updated successfully.',
  dist_status_successs_msg: 'Distributor status updated successfully.',
  dist_flags_success_msg: 'Distributor flags are updated successfully',
  car_program_update_success_msg: 'Car Program updated successfully',
  car_program_remove_success_msg: 'Removed successfully from Car Program'
};

export const USERS_GROUP_UMS = {
  ug_duplicate_name: 'Duplicate user names are not allowed.',
  ug_duplicate_email: 'Duplicate email ids are not allowed.',
  ug_invalid_email: 'Enter valid Email.',
  ug_user_created: 'User is successfully created.',
  ug_user_group_created: 'User group is successfully created.',
  ug_group_exists: 'Group name already exists.',
  ug_group_required: 'Please associate a Group to each User.',
  ug_group_operation_successful: 'Operation is successful.'
};

export const EQUIVALENCY_SETUP_UMS = {
  es_plan_creation_error: 'Error in loading all plans.',
  es_duplicate_names: 'Duplicate equivalency names are not allowed.',
  es_min_plans_required: 'Atleast two plans are required for creation of Equivalency record.',
  es_min_plans_selection: 'Atleast two plans need to be selected for creation of Equivalency record.',
  es_names_saved: 'Equivalency rules are saved successfuly.',
  es_invalid_name: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *'
};

export const OVERRIDES_UMS = {
  or_invalid_name: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *',
  or_duplicate_name: 'Duplicate names are not allowed.',
  duplicate_rule_code: 'Duplicate Rule Codes are not allowed',
  invalide_rule_code: 'Rule Code has invalid characters. Allowed characters are a-z A-Z 0-9',
  duplicate_override_code: 'Duplicate Override Codes are not allowed',
  invalid_override_code: 'Override Code has invalid characters. Allowed characters are a-z A-Z 0-9'
};

export const PLAN_DETAILS_UMS = {
  pd_plan_creation: 'Plan Details Created Successfully.',
  pd_plan_exists: 'Plan with name "{0}"" already exists. Please change the plan name.',
  pd_code_exists: 'Plan with code "{0}"" already exists. Please change the plan code.',
  pd_plan_name_invalid_characters: 'Plan name contains invalid characters. Allowed characters are a-z A-Z 0-9 - _ *',
  pd_plan_code_invalid_characters: 'Plan code contains invalid characters. Allowed characters are a-z A-Z 0-9 - _ *',
  pd_plan_update: 'Plan is updated successfully.',
  pd_company_plan_association: 'Company associated with this plan is no more available. Please select a company to associate this plan.',
  pd_plan_summary_udpate: 'Plan Summary Updated Successfully.'
};

export const PLAN_LIST_UMS = {
  pl_plan_fetch_error: 'Error in loading all plans.'
};

export const PLAN_PERIOD_UMS = {
  pp_saved: 'Plan Period Saved Successfully.',
  pp_invalid_name: 'Plan Segment name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  pp_duplicate_name: 'Duplicate names are not allowed.'
};

export const PLAN_WIZARD_UMS = {
  pw_plan_not_available: 'Plan is not available. Please create a new plan or edit an existing plan to go to {0} tab.'
};

export const TITLE_UMS = {
  tt_duplicate_name: 'Duplicate title names are not allowed.',
  tt_duplicate_code: 'Duplicate title codes are not allowed.',
  tt_duplicate_rule: 'Duplicate rule codes are not allowed.',
  tt_duplicate_rank: 'Duplicate "Rank" values are not allowed.',
  tt_invalid_name: 'Title name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  tt_invalid_code: 'Title code has invalid characters. Allowed characters are a-z A-Z.',
  tt_duplicate_override: 'Duplicate Overrides are not allowed.'
};

export const TITLE_TYPES_UMS = {
  tty_plan_not_available: 'Plan id is not available to load Title Types',
  tty_class_period_duplicate: 'Duplicate Class selection not allowed for the selected Class.',
  tty_title_type_name_duplicate: 'Duplicate Type Names are not allowed.',
  tty_title_type_code_duplicate: 'Duplicate Type Codes are not allowed.',
  tty_title_name_invalid: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ * with atleast one alphabet'
};

export const VOLUMES_UMS = {
  vol_duplicate_code: 'Duplicate volume code are not allowed.',
  vol_duplicate_name: 'Duplicate volume name are not allowed.',
  vol_duplicate_type_basevolume: 'Duplicate volume type and base volume values are not allowed.',
  vol_support_characters_name: 'Supported characters for Volume Name are a-z A-Z 0-9 - _ *',
  vol_support_characters_code_basevolume: 'Supported characters for Volume Code & Base Volume are a-z A-Z',
  vol_updation: 'Volume definitions are updated successfully.'
};

export const KEYMETRICS_UMS = {
  vol_duplicate_code: 'Duplicate Key Metric codes are not allowed.',
  vol_duplicate_name: 'Duplicate Key Metric names are not allowed.',
  vol_duplicate_type_basevolume: 'Duplicate volume type and base volume values are not allowed.',
  vol_support_characters_name: 'Supported characters for Key Metric Name is a-z A-Z 0-9 - _ *',
  vol_support_characters_code_basevolume: 'Supported characters for Key Metric Code & Base Volume are a-z A-Z',
  vol_updation: 'Key Metric definitions are updated successfully.',
  km_criteria_error_message: 'Criteria already exists. Please select a different criteria.',
  vol_duplicate_materials: 'Duplicate Materials are not allowed',
  vol_required_fields_empty: 'Missing required fields Condition, Material Group Name and Min Value.',
  vol_required_materialGroup_Name_And_minValue: 'Missing required fields Material Group Name and Min Value.',
  vol_condition_required: 'Condition is required.',
  vol_minValue_required: 'Min Value is required.',
  vol_materialGroup_Name_required: 'Material Group Name is required.'
};

export const EARNING_CODES_UMS = {
  ec_updation: 'Earning Codes are updated successfully.',
  ec_duplicate_code: 'Duplicate earning code is not allowed.',
}

export const CC_COLUMN_SELECTOR_MODAL_UMS = {
  acm_col_not_available: 'Columns are not available.'
};

export const CC_FILTER_MODAL_UMS = {
  afm_filter_not_available: 'Filters are not available now. Please try later'
};

export const ANALYTICS_SORT_MODAL_UMS = {
  asm_select_col: 'Please select column name from available list of columns',
  asm_duplicate_col_selection: 'Duplicate column selections are not allowed'
};

export const COMPENSATION_BUILDER_UMS = {
  cb_duplicate_code: 'Duplicate Compensation Code is not allowed',
  cb_duplicate_rule: 'Duplicate Rule Code is not allowed'
};

export const PERSONAL_GROUP_FUNCTIONS_UMS = {
  pgf_creation: 'Group Functions Created Successfully.',
  pgf_updation: 'Group Functions Updated Successfully.'
};

export const FLAGS_UMS = {
  fl_duplicate_code: 'Duplicate codes are not allowed.',
  fl_duplicate_name: 'Duplicate names are not allowed.',
  fl_duplicate_value: 'Duplicate values are not allowed.',
  f1_invalid_code: 'Code has invalid characters. Allowed characters are a-z A-Z.',
  fl_invalid_name: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  fl_invalid_value: 'Value has invalid characters. Allowed characters are a-z A-Z.'
};

export const INCENTIVES_UMS = {
  in_duplicate_code: 'Duplicate codes are not allowed.',
  in_duplicate_name: 'Duplicate names are not allowed.',
  in_invalid_code: 'Code has invalid characters. Allowed characters are a-z A-Z.',
  in_invalid_name: 'Name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
};

export const COMPENSATON_RATE_CARD_UMS = {
  rc_duplicate_name: 'Duplicate Rate Card names are not allowed.',
  rc_duplicate_rate_card_name: 'Duplicate Rate Card Names are not allowed.',
  rc_invalid_name: 'Rate Card name has invalid characters. Allowed characters are a-z A-Z 0-9 - _ *.',
  rc_duplicate_criteria: "Duplicate criterias are not allowed.",
  rc_criteria_error_message: "Please Select Criteria Field",
  rc_codition_error_message: "Please select the condition"
};

export const DD_OVERRID_CARD_UMS = {
  over_invalid_rate: 'Invalid Rate. Allowed from 0 to ',
  ov_startDate_greaterthan_endDate: 'Start date cannot be greater than End date',
  ov_startDate_equal_endDate: 'End date cannot be same as Start date'
};

export const TAX_SETUP_UMS = {
  invalid_lower_limit: 'Invalid Lower Limit. It should be greater than or equal to 0',
  invalid_lower_limit_tax: 'Invalid Lower Limit Tax. It should be greater than or equal to 0',
  invalid_overage_rate: 'Invalid Overage Rate. It should be between 0 to 100'
};

export const EDIT_REMOVE_CAR_PROGRAM_UMS = {
  enrollmentDate_empty_message: 'Program Start date cannot be empty',
  engineType_empty_message: 'Vehicle Type cannot be empty',
  bankEndDate_empty_message: 'Bank Until date cannot be empty',
  expirationDate_empty_message: 'Expiration date cannot be empty',
  enrollmentDate_greaterthan_bankEndDate : 'Program Start date cannot be greater than Bank Until date',
  enrollmentDate_greaterthan_expirationDate : 'Program Start date cannot be greater than Expiration date',
  release_banked_bonus_msg: 'Please release banked bonus before switching to non banked.'
};

export const ADHOC_PAYMENT = {
  adHoc_payment_bonus_error_message: 'The bonus amount should be in the range of -9999.99 to +9999.99'
};

export const VALUE_CHAIN_VOLUMES = {
  duplicate_groupId_message: 'Duplicate GroupIDs are not allowed.',
  duplicate_volume_code: 'Duplicate Volume Codes are not allowed.'
};

export const QUARTER_STRUCTURE = {
  duplicate_months_message: 'One period/month cannot belong to multiple Quarters.',
  invalid_quarter_start_message: 'Invalid Selection of Quarter Start',
  invalid_quarter_end_message: 'Invalid Selection of Quarter End',
}

export const GDPR_UMS = {
  fields_need_value_message: 'All fields must have a value.',
  greater_or_equal_to_zero_message: 'All fields must have a value greater than or equal to 0.'
}

export const RATE_CARD_MESSAGES = {
  from_lesser_than_prev_to_message : 'From value must be greater than previous to value.'
}